export default __webpack_public_path__ + "static/media/logo-company-11.9ec8a255.png";